import React from 'react';

interface IconProps extends React.SVGProps<SVGSVGElement> {
  width?: number | string;
  height?: number | string;
  isActive?: boolean;
}

const PlansAndBillingIcon: React.FC<IconProps> = ({
  width = 14,
  height = 11,
  ...props
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 14 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.3333 3.10696e-09C11.8435 -2.84145e-05 12.3343 0.194883 12.7055 0.544856C13.0767 0.894828 13.3001 1.3734 13.33 1.88267L13.3333 2V8.66667C13.3334 9.17681 13.1384 9.66768 12.7885 10.0388C12.4385 10.41 11.9599 10.6334 11.4507 10.6633L11.3333 10.6667H2C1.48986 10.6667 0.99899 10.4718 0.627826 10.1218C0.256662 9.77184 0.0332617 9.29326 0.00333341 8.784L3.10696e-09 8.66667V2C-2.84145e-05 1.48986 0.194883 0.99899 0.544856 0.627826C0.894828 0.256662 1.3734 0.0332617 1.88267 0.00333341L2 3.10696e-09H11.3333ZM12 4H1.33333V8.66667C1.33335 8.82996 1.3933 8.98756 1.50181 9.10958C1.61032 9.2316 1.75983 9.30956 1.922 9.32867L2 9.33333H11.3333C11.4966 9.33331 11.6542 9.27336 11.7762 9.16486C11.8983 9.05635 11.9762 8.90683 11.9953 8.74467L12 8.66667V4ZM8.47133 4.976L9.69 6.19533C9.81498 6.32035 9.88519 6.48989 9.88519 6.66667C9.88519 6.84344 9.81498 7.01298 9.69 7.138L8.47133 8.35667C8.40983 8.42034 8.33627 8.47113 8.25494 8.50607C8.1736 8.54101 8.08612 8.5594 7.9976 8.56017C7.90908 8.56094 7.82129 8.54407 7.73936 8.51055C7.65743 8.47703 7.583 8.42753 7.5204 8.36493C7.45781 8.30234 7.40831 8.2279 7.37479 8.14597C7.34126 8.06404 7.3244 7.97625 7.32517 7.88773C7.32593 7.79921 7.34433 7.71173 7.37927 7.6304C7.4142 7.54906 7.46499 7.4755 7.52867 7.414L7.60867 7.33333H4.66667C4.48986 7.33333 4.32029 7.2631 4.19526 7.13807C4.07024 7.01305 4 6.84348 4 6.66667C4 6.48986 4.07024 6.32029 4.19526 6.19526C4.32029 6.07024 4.48986 6 4.66667 6H7.60933L7.52867 5.91933C7.40357 5.79433 7.33326 5.62475 7.3332 5.4479C7.33314 5.27106 7.40333 5.10143 7.52833 4.97633C7.65334 4.85124 7.82292 4.78093 7.99976 4.78086C8.17661 4.7808 8.34624 4.85099 8.47133 4.976ZM11.3333 1.33333H2C1.82319 1.33333 1.65362 1.40357 1.5286 1.5286C1.40357 1.65362 1.33333 1.82319 1.33333 2V2.66667H12V2C12 1.82319 11.9298 1.65362 11.8047 1.5286C11.6797 1.40357 11.5101 1.33333 11.3333 1.33333Z"
        fill="#6E5E83"
      />
    </svg>
  );
};

export default PlansAndBillingIcon;
